import {
  Card,
  Col,
  Button,
  Row,
} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Admin from './Admin'
import useIsAdmin from '../hooks/useIsAdmin'

const AdminContainer = () => {
  const admin = useIsAdmin()
  const navigate = useNavigate()

  if (!admin) {
    <Row>
      <Col md={{ span: 6, offset: 3 }}>
        <Card>
          <Card.Header>
            <i className="fa fa-do-not-enter" />
          </Card.Header>
          <Card.Body className="text-center">
            <p className="lead">You must be an admin to access this area.</p>

            <Button variant="outline-secondary" className="me-2" onClick={() => navigate('/')}>
              Back
            </Button>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  }

  return (
    <Admin />
  )
}

export default AdminContainer
